var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Instagram2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.264,
    height: 66.264,
    viewBox: "0 0 66.264 66.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.011,
    y1: -0.011,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#fbe18a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fcbb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#f75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#d53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#8f39ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4fe9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 66.264,
    height: 66.264,
    rx: 9.128,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(13.945 14.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M385.355,162.048a2.25,2.25,0,1,0,2.251,2.251A2.249,2.249,0,0,0,385.355,162.048Z",
    transform: "translate(-356.009 -155.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M383.194,163.618a9.45,9.45,0,1,0,9.449,9.451A9.463,9.463,0,0,0,383.194,163.618Zm0,15.505a6.054,6.054,0,1,1,6.052-6.054A6.061,6.061,0,0,1,383.194,179.123Z",
    transform: "translate(-363.849 -153.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M395.205,196.694h-15.32a11.54,11.54,0,0,1-11.527-11.527V169.845a11.539,11.539,0,0,1,11.527-11.526h15.32a11.54,11.54,0,0,1,11.527,11.526v15.322A11.542,11.542,0,0,1,395.205,196.694Zm-15.32-34.764a7.924,7.924,0,0,0-7.917,7.915v15.322a7.926,7.926,0,0,0,7.917,7.917h15.32a7.926,7.926,0,0,0,7.917-7.917V169.845a7.924,7.924,0,0,0-7.917-7.915Z",
    transform: "translate(-368.358 -158.319)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram2.25cf7c1885510bc1c6f523ff04ee632a.svg";
export { ForwardRef as ReactComponent };